var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatureImage2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 53,
    viewBox: "0 0 58 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1014_1363)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1014_1363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6141 44.5929C22.8311 44.5929 17.048 44.5993 11.2663 44.5904C7.91283 44.5853 5.32756 42.6521 4.37308 39.4837C4.16125 38.7793 4.13318 38.0596 4.1319 37.3373C4.12552 30.4914 4.12297 23.6454 4.1268 16.7994C4.12807 15.4812 4.11914 14.1618 4.18932 12.8475C4.35649 9.70457 6.26162 6.59995 10.3309 5.91343C19.5912 4.35155 28.8502 2.77691 38.1041 1.1793C40.5464 0.756933 42.8088 0.999382 44.7701 2.64676C46.0309 3.70587 46.8501 5.04445 47.1819 6.66885C47.2393 6.95214 47.252 7.13206 46.8386 7.12823C43.332 7.09761 39.8242 7.08357 36.3163 7.07974C30.555 7.07336 24.7936 7.07846 19.0323 7.07974C18.6291 7.07974 18.2233 7.07464 17.8213 7.10526C17.1157 7.16013 16.6588 7.62206 16.6257 8.28178C16.5938 8.91852 17.0212 9.47998 17.6861 9.59993C18.0804 9.67139 18.49 9.69053 18.8919 9.69053C27.8217 9.69308 36.7502 9.68925 45.68 9.68925C50.0632 9.68925 53.0491 12.6765 53.0504 17.0559C53.0517 23.8597 53.0555 30.6636 53.0491 37.4675C53.0453 41.0289 50.6667 43.9319 47.2342 44.496C45.7629 44.7384 44.2623 44.5891 42.7757 44.5929C38.0556 44.607 33.3368 44.598 28.6167 44.598C28.6141 44.598 28.6141 44.5955 28.6141 44.5929ZM44.3631 27.1481C44.3439 25.2481 42.7208 23.6275 40.8527 23.6441C38.9692 23.6607 37.3435 25.3183 37.3831 27.1826C37.4239 29.1183 39.0011 30.6572 40.919 30.6317C42.7948 30.6062 44.3809 29.0035 44.3631 27.1481Z",
    fill: "#50B7EC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1014_1363",
    x: 0.673204,
    y: 0.99707,
    width: 55.8313,
    height: 50.5413,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.4518
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.7259
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.313726 0 0 0 0 0.717647 0 0 0 0 0.92549 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1014_1363"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1014_1363",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1014_1363",
    x: 0.125,
    y: 0.99707,
    width: 56.9277,
    height: 51.6377,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1014_1363"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1014_1363",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureImage2);
export default __webpack_public_path__ + "static/media/FeatureImage2.28faaacdd6e2bb77b2caac1c5aaf362a.svg";
export { ForwardRef as ReactComponent };